import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import api from '../../utils/api';
import SEO from '../../components/SEO';
import '../PageStyles.css';

const BlogPost = () => {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchPost = async () => {
      try {
        const response = await api.get(`/blog/${slug}`);
        setPost(response.data);
      } catch (err) {
        setError('Blog post not found');
      } finally {
        setLoading(false);
      }
    };
    fetchPost();
  }, [slug]);

  if (loading) return <div className="loading">Loading...</div>;
  if (error) return <div className="error">{error}</div>;

  return (
    <>
      <SEO
        title={post?.title}
        description={post?.excerpt || post?.content?.substring(0, 160)}
        image={post?.featured_image_url}
        keywords={`blog, ${post?.title}`}
      />
      <div className="page-container">
      <div className="container">
        {post.featured_image_url && (
          <img
            src={post.featured_image_url}
            alt={post.title}
            style={{ width: '100%', maxHeight: '400px', objectFit: 'cover', borderRadius: '8px' }}
          />
        )}
        <h1>{post.title}</h1>
        {post.published_at && (
          <p style={{ color: 'var(--secondary-color)' }}>
            Published on {new Date(post.published_at).toLocaleDateString()}
          </p>
        )}
        <div className="content-section">
          <p style={{ whiteSpace: 'pre-wrap' }}>{post.content}</p>
        </div>
      </div>
      </div>
    </>
  );
};

export default BlogPost;
